import type { Utility } from '../../../types/utility';
import { mqMin } from '../../breakpoints';

const base: Utility.CSSProperties = {
  backgroundColor: 'coolGrey.0',
  position: 'absolute',
  top: '100%',
  left: '0',
  minWidth: '100%',
  right: 'auto',
  listStyle: 'none',
  margin: '0',
  padding: 0,
  border: '1px solid',
  borderColor: 'coolGrey.40',
  overflow: 'hidden',
  zIndex: 'z500',
  fontWeight: 'regular',
  a: { color: 'inherit', fontWeight: 'inherit' },
  'li:hover, li[data-visual-focus="true"]': {
    backgroundColor: 'coolGrey.10',
  },
  '&:empty': {
    display: 'none',
  },
};

const chart = {
  default: {
    ...base,
    marginTop: 's8',
    borderRadius: 'form',
  },
  splitDark: {
    ...base,
    fontSize: 'fs12',
    backgroundColor: 'coolGrey.80',
    color: 'white',
    [mqMin.mobile]: {
      gridTemplateColumns: 'repeat(2, auto)',
    },
    'li:hover, li[data-visual-focus="true"]': {
      backgroundColor: 'coolGrey.100',
    },
  },
  large: {
    ...base,
    marginTop: 's8',
    gridTemplateColumns: 'auto',
    borderRadius: 'base',
    padding: 's16',
    boxShadow: 'nav',
    'li[aria-selected="true"]': {
      backgroundColor: 'blue.10',
    },
    'li:hover, li[data-visual-focus="true"]': {
      backgroundColor: 'coolGrey.10',
    },
    [mqMin.mobile]: {
      gridTemplateColumns: 'repeat(2, auto)',
    },
    [mqMin.tabletLandscape]: {
      gridTemplateColumns: 'repeat(4, auto)',
    },
  },
  blueHighlight: {
    ...base,
    marginTop: 's8',
    boxShadow: 'nav',
    backgroundColor: 'white',
    borderRadius: 'base',
    paddingTop: 's8',
    paddingBottom: 's8',
    'li[aria-selected="true"]': {
      backgroundColor: 'blue.60',
      color: 'white',
    },
    'li:hover, li[data-visual-focus="true"]': {
      backgroundColor: 'blue.10',
    },
  },
  form: {
    ...base,
    boxShadow: 'nav',
    marginTop: 's8',
    borderRadius: 'base',
    'li[aria-selected="true"]': {
      backgroundColor: 'coolGrey.70',
      color: 'white',
    },
    'li:hover, li[data-visual-focus="true"]': {
      '&, &[aria-selected="true"]': {
        backgroundColor: 'coolGrey.100',
        color: 'white',
      },
    },
  },
  simple: {
    ...base,
    boxShadow: 'nav',
    marginTop: 's8',
    borderRadius: 'base',
    'li[aria-selected="true"]': {
      fontWeight: '600',
    },
    'li:hover, li[data-visual-focus="true"]': {
      '&, &[aria-selected="true"]': {
        backgroundColor: 'coolGrey.100',
        color: 'white',
      },
    },
  },
};

const list: Utility.VariantKeyModes<ListVariantsType> = {
  ...chart,
  products: {
    chart,
    chartblog: chart,
    co: chart,
    edu: chart,
    scale: chart,
    spark: chart,
  },
};

export type ListVariantsType = 'default' | 'splitDark' | 'large' | 'blueHighlight' | 'form' | 'simple';
export const listVariants = Object.keys(chart) as ListVariantsType[];

export default list;
